import { render } from "./Troublemaker.vue?vue&type=template&id=b42bdf5e&scoped=true&ts=true"
import script from "./Troublemaker.vue?vue&type=script&lang=ts"
export * from "./Troublemaker.vue?vue&type=script&lang=ts"

import "./Troublemaker.vue?vue&type=style&index=0&id=b42bdf5e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42bdf5e"]])

export default __exports__